import React, { useEffect, useState } from "react";
import {
  Button,
  styled,
  Dialog,
  DialogTitle,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { InterviewHistoryAction } from "./../../../Redux/action/InterviewHistoryAction";
import { InterviewPlannedAction } from "../../../Redux/action/InterviewPlannedAction";

import { CancelInterviewAction } from "./../../../Redux/action/CancelInterviewVendorAction";
import { MdCancel } from "react-icons/md";
import { SpinLoader } from "../ImportCandidates";

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextareaAutosize,
} from "@mui/material";
import { useLocation } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const CancelInterview = (props) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const interviewId = props.data;
  const { userResult } = useSelector((state) => state.Auth);
  let vendorid = userResult?.vendorid;
  const location = useLocation();
  const loading = useSelector(
    (state) => state?.CancelInterviewReducer?.loading
  );
  const [data, setData] = useState({
    interviewCancellationReason: "",
    candidateInterviewStatus: "",
    ratings: "",
  });
  const [selectedOption, setSelectedOption] = useState(null);
  // const [loading, setLoading] = useState(false);

  const [selectedReason, setSelectedReason] = useState(""); // To store the selected reason

  console.log("LLLL", loading);
  const [showOtherTextarea, setShowOtherTextarea] = useState(
    selectedReason === "other"
  );

  const [otherReason, setOtherReason] = useState("");

  const handleOtherReasonChange = (event) => {
    setOtherReason(event.target.value);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleReasonChange = (event) => {
    const value = event.target.value;
    setSelectedReason(value);
    // If "other" is selected, show the textarea
    setShowOtherTextarea(value === "other");
  };

  const handleCheckboxChange = (label) => {
    setSelectedOption(label);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let dispatch = useDispatch();
  useEffect(() => {
    if (!loading && open) {
      handleClose();
      if (location.pathname === "/interview-history") {
        setTimeout(() => {
          dispatch(InterviewHistoryAction(vendorid, 0))
        }, 2000)
      } else {
        setTimeout(() => {
          dispatch(InterviewPlannedAction(vendorid, 0));
        }, 2000)
      }
    }
  }, [loading]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedReason) {
      setError("Please select one option.");
      toast.error("Please select one option");
      return; 
    }

    if (selectedReason === "other" && (!otherReason || otherReason.trim() === "")) {
      return toast.error("Please provide a reason in the 'Other' field");
    } else {
      let content = {
        interviewId,
        interviewCancellationReason: selectedReason,
      };
      dispatch(CancelInterviewAction(content)).then((res) => {
        if(res?.data){
          handleClose()
        }
      })
      setError("");
    }
  };

  return (
    <>
      {/* <ToastContainer /> */}

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        {/* <ToastContainer /> */}

        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          <b>Cancel Interview</b>
        </BootstrapDialogTitle>
        <FormControl style={{ padding: "10px", }}>
          <FormLabel id="demo-radio-buttons-group-label">Reasons
          <span style={{color:'red',paddingLeft:4}} className="text-red-700 pl-[2px]">*</span>
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            // defaultValue="female"
            name="radio-buttons-group"
            value={selectedReason}
            onChange={handleReasonChange}
          >
            <FormControlLabel
              className="mb-2"
              value="Position filled"
              control={<Radio />}
              label="Position filled"
            />

            <FormControlLabel
              className="mb-2"
              value="Changed hiring needs"
              control={<Radio />}
              label="Changed hiring needs"
            />

            <FormControlLabel
              className="mb-2"
              value="Interviewer unavailable"
              control={<Radio />}
              label="Interviewer unavailable"
            />

            <FormControlLabel
              className="mb-2"
              control={<Radio />}
              value={"other"}
              label="Others"
            />

            {showOtherTextarea && (
              <TextareaAutosize
                value={otherReason}
                onChange={handleOtherReasonChange}
                placeholder="Other Reason"
                minRows={5}
                maxRows={5}
              />
            )}
          </RadioGroup>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              variant="contained"
              className="common_btn"
              style={{
                background: "#1c6597",
                color: "#fff",
                marginRight: "10px",
                width: "100px",
                height: "40px",
              }}
              disabled={loading }
              onClick={handleSubmit} // Add your submit logic here
            >
              {!loading ? "Submit" : <SpinLoader />}
            </button>
          </div>
        </FormControl>
      </BootstrapDialog>
      <span onClick={handleClickOpen}>Cancel</span>
    </>
  );
};

export default CancelInterview;